import {
  CoachingPracticeReportView,
  CoachingReplaySummary,
} from '@euler/model/coaching-practice';
import { useServiceFactory } from '@euler/services/factory';
import { useCallback, useEffect, useState } from 'react';

export type PracticeReportState =
  /** The first ask writes the closing pass: 正在复盘. */
  | { kind: 'reviewing' }
  | { kind: 'failed' }
  | {
      kind: 'ready';
      report: CoachingPracticeReportView;
      replays: CoachingReplaySummary[];
    };

/** An ended practice's report, with the moments already replayed. */
export function usePracticeReport(attemptId: string) {
  const { coachingService } = useServiceFactory();
  const [state, setState] = useState<PracticeReportState>({
    kind: 'reviewing',
  });
  const [reloadKey, setReloadKey] = useState(0);
  const reload = useCallback(() => setReloadKey(k => k + 1), []);
  useEffect(() => {
    let current = true;
    setState(x => (x.kind === 'ready' ? x : { kind: 'reviewing' }));
    Promise.all([
      coachingService.practiceReport(attemptId),
      coachingService.listReplays(attemptId).catch(error => {
        // The report reads without its replay marks.
        console.error('coaching replays failed', error);
        return [];
      }),
    ])
      .then(([report, replays]) => {
        if (current) setState({ kind: 'ready', report, replays });
      })
      .catch(error => {
        console.error('coaching practice report failed', error);
        if (current) setState({ kind: 'failed' });
      });
    return () => {
      current = false;
    };
  }, [attemptId, coachingService, reloadKey]);
  return { state, reload };
}
